// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"a7bfb90e","301":"853cfe76","379":"a63d7c22"}[chunkId] + ".chunk.js";
};